module.exports = __webpack_public_path__ + "img/light-mud-decal-26.47136b6c.png";